(function (global) {
    'use strict';

    const OUTDOOR_CLAUSE = '(title:outdoor OR tag:outdoor OR tag:"Outdoor: true")';
    const WASHABLE_CLAUSE = '(title:washable OR tag:washable OR tag:"Machine Washable: true" OR ' +
        'tag:"Machine-Washable: true" OR tag:"machine washable" OR tag:machine-washable)';
    const GENERIC_WORDS = new Set(['rug', 'rugs', 'carpet', 'carpets']);

    const concepts = [
        {
            name: 'Beige',
            aliases: ['Beige'],
            clause: 'tag:"Beige"'
        },
        {
            name: 'Black',
            aliases: ['Black'],
            clause: 'tag:"Black"'
        },
        {
            name: 'Blue',
            aliases: ['Blue'],
            clause: 'tag:"Blue"'
        },
        {
            name: 'Brown',
            aliases: ['Brown'],
            clause: 'tag:"Brown"'
        },
        {
            name: 'Burgundy',
            aliases: ['Burgundy'],
            clause: 'tag:"Burgundy"'
        },
        {
            name: 'Copper',
            aliases: ['Copper'],
            clause: 'tag:"Copper"'
        },
        {
            name: 'Cream',
            aliases: ['Cream'],
            clause: 'tag:"Cream"'
        },
        {
            name: 'Gold',
            aliases: ['Gold'],
            clause: 'tag:"Gold"'
        },
        {
            name: 'Green',
            aliases: ['Green'],
            clause: 'tag:"Green"'
        },
        {
            name: 'Grey',
            aliases: ['Grey', 'gray'],
            clause: 'tag:"Grey"'
        },
        {
            name: 'Orange',
            aliases: ['Orange'],
            clause: 'tag:"Orange"'
        },
        {
            name: 'Pink',
            aliases: ['Pink'],
            clause: 'tag:"Pink"'
        },
        {
            name: 'Purple',
            aliases: ['Purple'],
            clause: 'tag:"Purple"'
        },
        {
            name: 'Red',
            aliases: ['Red'],
            clause: 'tag:"Red"'
        },
        {
            name: 'Silver',
            aliases: ['Silver'],
            clause: 'tag:"Silver"'
        },
        {
            name: 'Taupe',
            aliases: ['Taupe'],
            clause: 'tag:"Taupe"'
        },
        {
            name: 'Teal',
            aliases: ['Teal'],
            clause: 'tag:"Teal"'
        },
        {
            name: 'Terracotta',
            aliases: ['Terracotta', 'terra cotta'],
            clause: 'tag:"Terracotta"'
        },
        {
            name: 'Yellow',
            aliases: ['Yellow'],
            clause: 'tag:"Yellow"'
        },
        {
            name: 'White',
            aliases: ['White'],
            clause: 'tag:"White"'
        },
        {
            name: 'Multi-Coloured',
            aliases: [
                'Multi-Coloured',
                'multi-colour',
                'multicolour',
                'multi-colored',
                'multicolored',
                'multi-coloured',
                'multicoloured'
            ],
            clause: 'tag:"Multi-Coloured"'
        },
        {
            name: 'Acrylic',
            aliases: ['Acrylic'],
            clause: 'tag:"Acrylic"'
        },
        {
            name: 'Cotton',
            aliases: ['Cotton'],
            clause: 'tag:"Cotton"'
        },
        {
            name: 'Hemp',
            aliases: ['Hemp'],
            clause: 'tag:"Hemp"'
        },
        {
            name: 'Leather',
            aliases: ['Leather'],
            clause: 'tag:"Leather"'
        },
        {
            name: 'Microfibre',
            aliases: ['Microfibre'],
            clause: 'tag:"Microfibre"'
        },
        {
            name: 'Natural',
            aliases: ['Natural'],
            clause: 'tag:"Natural"'
        },
        {
            name: 'Nylon',
            aliases: ['Nylon'],
            clause: 'tag:"Nylon"'
        },
        {
            name: 'Polyester',
            aliases: ['Polyester'],
            clause: 'tag:"Polyester"'
        },
        {
            name: 'Polypropylene',
            aliases: ['Polypropylene'],
            clause: 'tag:"Polypropylene"'
        },
        {
            name: 'Silk',
            aliases: ['Silk'],
            clause: 'tag:"Silk"'
        },
        {
            name: 'Viscose',
            aliases: ['Viscose'],
            clause: 'tag:"Viscose"'
        },
        {
            name: 'Wool',
            aliases: ['Wool'],
            clause: 'tag:"Wool"'
        },
        {
            name: 'Rectangular',
            aliases: ['Rectangular', 'rectangle'],
            clause: 'tag:"Rectangular"'
        },
        {
            name: 'Runner',
            aliases: ['Runner', 'runners', 'hall runner', 'hallway runner'],
            clause: 'tag:"Runner"'
        },
        {
            name: 'Round',
            aliases: ['Round', 'circle', 'circular'],
            clause: 'tag:"Round"'
        },
        {
            name: 'Square',
            aliases: ['Square', 'squares'],
            clause: 'tag:"Square"'
        },
        {
            name: 'Hide',
            aliases: ['Hide'],
            clause: 'tag:"Hide"'
        },
        {
            name: 'Half-Moon',
            aliases: ['Half-Moon', 'semicircle', 'semi-circle', 'semicircular'],
            clause: 'tag:"Half-Moon"'
        },
        {
            name: 'Octagon',
            aliases: ['Octagon', 'octagonal'],
            clause: 'tag:"Octagon"'
        },
        {
            name: 'Asymmetric',
            aliases: ['Asymmetric', 'asymmetrical'],
            clause: 'tag:"Asymmetric"'
        },
        {
            name: 'Abstract',
            aliases: ['Abstract'],
            clause: 'tag:"Abstract"'
        },
        {
            name: 'Action Painting',
            aliases: ['Action Painting'],
            clause: 'tag:"Action Painting"'
        },
        {
            name: 'All-over Floral',
            aliases: ['All-over Floral'],
            clause: 'tag:"All-over Floral"'
        },
        {
            name: 'Animal Print',
            aliases: ['Animal Print'],
            clause: 'tag:"Animal Print"'
        },
        {
            name: 'Berber',
            aliases: ['Berber'],
            clause: 'tag:"Berber"'
        },
        {
            name: 'Blocks',
            aliases: ['Blocks', 'block'],
            clause: 'tag:"Blocks"'
        },
        {
            name: 'Bordered',
            aliases: ['Bordered', 'border'],
            clause: 'tag:"Bordered"'
        },
        {
            name: 'Central Medallion',
            aliases: ['Central Medallion'],
            clause: 'tag:"Central Medallion"'
        },
        {
            name: 'Checkered',
            aliases: ['Checkered', 'check', 'checked', 'chequered'],
            clause: 'tag:"Checkered"'
        },
        {
            name: 'Chevron',
            aliases: ['Chevron'],
            clause: 'tag:"Chevron"'
        },
        {
            name: 'Circles',
            aliases: ['Circles', 'circle pattern'],
            clause: 'tag:"Circles"'
        },
        {
            name: 'Damask',
            aliases: ['Damask'],
            clause: 'tag:"Damask"'
        },
        {
            name: 'Diamonds',
            aliases: ['Diamonds', 'diamond'],
            clause: 'tag:"Diamonds"'
        },
        {
            name: 'Floral',
            aliases: ['Floral', 'flower', 'flowers', 'flowered'],
            clause: 'tag:"Floral"'
        },
        {
            name: 'Foliage',
            aliases: ['Foliage'],
            clause: 'tag:"Foliage"'
        },
        {
            name: 'Geometric',
            aliases: ['Geometric', 'geometrical'],
            clause: 'tag:"Geometric"'
        },
        {
            name: 'Gradient',
            aliases: ['Gradient'],
            clause: 'tag:"Gradient"'
        },
        {
            name: 'Honeycomb',
            aliases: ['Honeycomb'],
            clause: 'tag:"Honeycomb"'
        },
        {
            name: 'Modern',
            aliases: ['Modern'],
            clause: 'tag:"Style: Modern"'
        },
        {
            name: 'Outdoor',
            aliases: ['Outdoor'],
            clause: OUTDOOR_CLAUSE
        },
        {
            name: 'Patchwork',
            aliases: ['Patchwork'],
            clause: 'tag:"Patchwork"'
        },
        {
            name: 'Pictorial',
            aliases: ['Pictorial'],
            clause: 'tag:"Pictorial"'
        },
        {
            name: 'Plain',
            aliases: ['Plain', 'solid', 'solid colour', 'solid color'],
            clause: 'tag:"Plain"'
        },
        {
            name: 'Retro',
            aliases: ['Retro'],
            clause: 'tag:"Retro"'
        },
        {
            name: 'Stripes',
            aliases: ['Stripes', 'stripe', 'striped'],
            clause: 'tag:"Stripes"'
        },
        {
            name: 'Tartan',
            aliases: ['Tartan', 'plaid'],
            clause: 'tag:"Tartan"'
        },
        {
            name: 'Textured',
            aliases: ['Textured', 'texture'],
            clause: 'tag:"Textured"'
        },
        {
            name: 'Traditional',
            aliases: ['Traditional'],
            clause: 'tag:"Style: Traditional"'
        },
        {
            name: 'Trellis',
            aliases: ['Trellis'],
            clause: 'tag:"Trellis"'
        },
        {
            name: 'Triangles',
            aliases: ['Triangles', 'triangle'],
            clause: 'tag:"Triangles"'
        },
        {
            name: 'Tribal',
            aliases: ['Tribal'],
            clause: 'tag:"Tribal"'
        },
        {
            name: 'Vintage',
            aliases: ['Vintage'],
            clause: 'tag:"Vintage"'
        },
        {
            name: 'Washable',
            aliases: ['Washable', 'machine washable'],
            clause: WASHABLE_CLAUSE
        }
    ];

    function words(value) {
        const matches = String(value == null ? '' : value).toLowerCase().match(/[\p{L}\p{N}]+/gu);
        return matches || [];
    }

    function queryTokens(query) {
        const tokens = [];
        const tokenPattern = /[\p{L}\p{N}]+/gu;
        let match;

        while ((match = tokenPattern.exec(query))) {
            tokens.push({
                value: match[0].toLowerCase(),
                start: match.index,
                end: tokenPattern.lastIndex
            });
        }

        return tokens;
    }

    const aliases = concepts
        .flatMap(concept => concept.aliases.map(alias => ({
            concept,
            alias,
            words: words(alias)
        })))
        .filter(entry => entry.words.length)
        .sort((left, right) => right.words.length - left.words.length || right.alias.length - left.alias.length);

    function matchAt(tokens, start) {
        return aliases.find(entry => entry.words.every((word, offset) => (
            tokens[start + offset] && tokens[start + offset].value === word
        )));
    }

    function possessiveSuffix(query, tokens, lastTokenIndex) {
        const lastToken = tokens[lastTokenIndex];
        const suffixToken = tokens[lastTokenIndex + 1];
        const separator = suffixToken ? query.slice(lastToken.end, suffixToken.start) : '';

        if (suffixToken && suffixToken.value === 's' && /^[\u2019']$/.test(separator)) {
            return {end: suffixToken.end, tokenCount: 1};
        }

        return {end: lastToken.end, tokenCount: 0};
    }

    function isEscaped(value, index) {
        let slashCount = 0;
        for (let cursor = index - 1; cursor >= 0 && value[cursor] === '\\'; cursor -= 1) {
            slashCount += 1;
        }

        return slashCount % 2 === 1;
    }

    function syntaxInfo(value) {
        const unmatched = new Set();
        const stack = [];
        let quoteIndex = -1;
        let quoteCharacter = '';
        const quoteDelimiters = new Set();
        const balancedQuoteIndices = new Set();
        const literalApostropheIndices = new Set();
        const openingDelimiters = new Set(['(']);
        const closingDelimiters = new Map([
            [')', '(']
        ]);

        for (let index = 0; index < value.length; index += 1) {
            const character = value[index];

            if ((character === '"' || character === "'") && !isEscaped(value, index)) {
                const previousCharacter = value[index - 1];
                const nextCharacter = value[index + 1];
                const previousIsWord = isQueryWordCharacter(previousCharacter);
                const nextIsWord = isQueryWordCharacter(nextCharacter);
                const trailingApostrophe = character === "'" && previousIsWord && quoteIndex === -1 &&
                    (!nextCharacter || /[\s\p{P}\p{S}]/u.test(nextCharacter));
                const ordinaryApostrophe = character === "'" && previousIsWord &&
                    (nextIsWord || trailingApostrophe);

                if (ordinaryApostrophe) {
                    literalApostropheIndices.add(index);
                    continue;
                }

                if (quoteIndex === -1) {
                    quoteIndex = index;
                    quoteCharacter = character;
                    quoteDelimiters.add(index);
                } else if (quoteCharacter === character) {
                    quoteDelimiters.add(index);
                    for (let quoteOffset = quoteIndex; quoteOffset <= index; quoteOffset += 1) {
                        balancedQuoteIndices.add(quoteOffset);
                    }
                    quoteIndex = -1;
                    quoteCharacter = '';
                }
                continue;
            }

            if (character === '\u2019' && isQueryWordCharacter(value[index - 1])) {
                literalApostropheIndices.add(index);
            }

            if (quoteIndex !== -1) continue;

            if (isEscaped(value, index)) continue;

            if (openingDelimiters.has(character)) {
                stack.push({character, index});
                continue;
            }

            const openingDelimiter = closingDelimiters.get(character);
            if (!openingDelimiter) continue;

            if (stack.length && stack[stack.length - 1].character === openingDelimiter) {
                stack.pop();
            } else {
                unmatched.add(index);
            }
        }

        if (quoteIndex !== -1) unmatched.add(quoteIndex);
        stack.forEach(entry => unmatched.add(entry.index));

        return {
            unmatched,
            quoteDelimiters,
            balancedQuoteIndices,
            literalApostropheIndices
        };
    }

    function isBalancedSyntax(value) {
        return syntaxInfo(value).unmatched.size === 0;
    }

    function isQueryWordCharacter(character) {
        return /[\p{L}\p{N}]/u.test(character || '');
    }

    function standaloneConnectorLength(query, index) {
        const connector = query.slice(index).match(/^(?:AND|OR|NOT)/i);
        if (!connector) return 0;

        const before = query[index - 1];
        const after = query[index + connector[0].length];
        const hasLeftBoundary = index === 0 || /\s/u.test(before);
        const hasRightBoundary = connector[0].length === query.length - index || /\s/u.test(after);

        if (!hasLeftBoundary || !hasRightBoundary) return 0;
        if (isQueryWordCharacter(before) || isQueryWordCharacter(after)) return 0;
        return connector[0].length;
    }

    function hasStandaloneBooleanConnector(query) {
        const syntax = syntaxInfo(query);

        for (let index = 0; index < query.length; index += 1) {
            if (syntax.balancedQuoteIndices.has(index)) continue;

            const connectorLength = standaloneConnectorLength(query, index);
            if (!connectorLength) continue;

            const connector = query.slice(index, index + connectorLength).toUpperCase();
            if (connector === 'OR' || connector === 'NOT') return true;
            index += connectorLength - 1;
        }

        return false;
    }

    const SHOPIFY_ESCAPABLE_CHARACTERS = new Set([':', '\\', '(', ')']);
    const PRESERVABLE_ESCAPED_CHARACTERS = new Set([
        ...SHOPIFY_ESCAPABLE_CHARACTERS,
        '"',
        "'"
    ]);

    function isAttachedSymbol(character) {
        return character === '#' || /[\p{S}]/u.test(character || '');
    }

    function attachedPrefixLength(value) {
        let length = 0;

        while (length < value.length) {
            if (value[length] === '\\' && PRESERVABLE_ESCAPED_CHARACTERS.has(value[length + 1])) {
                length += 2;
            } else if (isAttachedSymbol(value[length])) {
                length += 1;
            } else {
                break;
            }
        }

        return length;
    }

    function attachedSuffixStart(value) {
        let start = value.length;

        while (start > 0) {
            if (start > 1 && value[start - 2] === '\\' &&
                PRESERVABLE_ESCAPED_CHARACTERS.has(value[start - 1])) {
                start -= 2;
            } else if (isAttachedSymbol(value[start - 1])) {
                start -= 1;
            } else {
                break;
            }
        }

        return start;
    }

    function sanitizeRemainingQuery(query) {
        const syntax = syntaxInfo(query);
        let sanitized = '';

        for (let index = 0; index < query.length; index += 1) {
            if (syntax.unmatched.has(index) && syntax.quoteDelimiters.has(index)) continue;

            if (!syntax.balancedQuoteIndices.has(index)) {
                const connectorLength = standaloneConnectorLength(query, index);
                const connector = query.slice(index, index + connectorLength).toUpperCase();
                if (connectorLength && connector === 'AND') {
                    index += connectorLength - 1;
                    continue;
                }
            }

            const character = query[index];
            if (character === '\\') {
                const nextCharacter = query[index + 1];
                if (PRESERVABLE_ESCAPED_CHARACTERS.has(nextCharacter)) {
                    sanitized += character + nextCharacter;
                    index += 1;
                } else {
                    sanitized += '\\\\';
                }
            } else if (SHOPIFY_ESCAPABLE_CHARACTERS.has(character)) {
                sanitized += `\\${character}`;
            } else {
                sanitized += character;
            }
        }

        return sanitized.replace(/\s+/g, ' ').trim();
    }

    function isModelLikeGroup(query, group) {
        return /[\p{N}#/+_-]/u.test(query.slice(group.start, group.end));
    }

    function removeRanges(query, ranges, tokens) {
        const remainingGroups = [];
        const syntax = syntaxInfo(query);
        const retainedTokens = tokens.map(token => !ranges.some(range => (
            token.start >= range.start && token.end <= range.end
        )));

        tokens.forEach((token, index) => {
            if (!retainedTokens[index]) return;

            const previousGroup = remainingGroups[remainingGroups.length - 1];
            if (previousGroup && retainedTokens[index - 1]) {
                previousGroup.end = token.end;
                previousGroup.lastTokenIndex = index;
            } else {
                remainingGroups.push({
                    start: token.start,
                    end: token.end,
                    firstTokenIndex: index,
                    lastTokenIndex: index
                });
            }
        });

        return remainingGroups
            .map(group => {
                let start = group.start;
                let end = group.end;
                const modelLikeGroup = isModelLikeGroup(query, group);

                if (group.firstTokenIndex === 0) {
                    start = 0;
                    if (!modelLikeGroup && /^[\[{]/u.test(query)) start = group.start;
                } else {
                    const beforeGap = query.slice(tokens[group.firstTokenIndex - 1].end, start);
                    const attachedStart = attachedSuffixStart(beforeGap);
                    if (attachedStart < beforeGap.length) start -= beforeGap.length - attachedStart;
                }

                if (group.lastTokenIndex === tokens.length - 1) {
                    end = query.length;
                } else {
                    const afterGap = query.slice(end, tokens[group.lastTokenIndex + 1].start);
                    const attachedLength = attachedPrefixLength(afterGap);
                    if (attachedLength) end += attachedLength;
                    if (syntax.literalApostropheIndices.has(end)) end += 1;
                }

                let candidateStart = start;
                let candidateEnd = end;

                if (group.firstTokenIndex !== 0) {
                    const beforeGap = query.slice(
                        tokens[group.firstTokenIndex - 1].end,
                        group.start
                    );
                    const opening = beforeGap.match(/["'([{]+$/u);
                    if (opening && (modelLikeGroup || !/[\[{]/u.test(opening[0]))) candidateStart = Math.min(
                        candidateStart,
                        group.start - opening[0].length
                    );
                }

                if (group.lastTokenIndex !== tokens.length - 1) {
                    const afterGap = query.slice(
                        group.end,
                        tokens[group.lastTokenIndex + 1].start
                    );
                    const closing = afterGap.match(/^\s*["'\)\]\}]+/u);
                    if (closing && (modelLikeGroup || !/[\]\}]/u.test(closing[0]))) candidateEnd = Math.max(
                        candidateEnd,
                        group.end + closing[0].length
                    );
                }

                if (isBalancedSyntax(query.slice(candidateStart, candidateEnd))) {
                    start = candidateStart;
                    end = candidateEnd;
                }

                return query
                    .slice(start, end)
                    .replace(/\s+/g, ' ')
                    .trim();
            })
            .filter(Boolean)
            .join(' ');
    }

    function refineQuery(originalQuery) {
        const original = String(originalQuery == null ? '' : originalQuery);

        if (hasStandaloneBooleanConnector(original)) {
            return {
                originalQuery: original,
                query: original,
                constrained: false,
                matchedConcepts: []
            };
        }

        const tokens = queryTokens(original);
        const matchedRanges = [];
        const matchedConcepts = [];
        const matchedNames = new Set();

        for (let index = 0; index < tokens.length;) {
            const match = matchAt(tokens, index);
            if (!match) {
                index += 1;
                continue;
            }

            const lastTokenIndex = index + match.words.length - 1;
            const suffix = possessiveSuffix(original, tokens, lastTokenIndex);
            matchedRanges.push({start: tokens[index].start, end: suffix.end});
            if (!matchedNames.has(match.concept.name)) {
                matchedNames.add(match.concept.name);
                matchedConcepts.push(match.concept.name);
            }
            index += match.words.length + suffix.tokenCount;
        }

        if (!matchedConcepts.length) {
            return {
                originalQuery: original,
                query: original,
                constrained: false,
                matchedConcepts: []
            };
        }

        tokens.forEach(token => {
            if (GENERIC_WORDS.has(token.value)) {
                matchedRanges.push({start: token.start, end: token.end});
            }
        });

        const remainingQuery = sanitizeRemainingQuery(removeRanges(original, matchedRanges, tokens));
        const clauses = matchedConcepts.map(name => concepts.find(concept => concept.name === name).clause);
        const queryParts = remainingQuery ? [remainingQuery, ...clauses] : clauses;

        return {
            originalQuery: original,
            query: queryParts.join(' AND '),
            constrained: true,
            matchedConcepts
        };
    }

    const api = {refineQuery};
    global.LrSearchVocabulary = api;
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
